import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=0449b946&scoped=true"
import script from "./ContactDetail.vue?vue&type=script&lang=ts"
export * from "./ContactDetail.vue?vue&type=script&lang=ts"
import style0 from "./ContactDetail.vue?vue&type=style&index=0&id=0449b946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0449b946",
  null
  
)

export default component.exports